import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3 11.331C3 6.72975 6.9885 3 11.9093 3C16.83 3 20.8185 6.72975 20.8185 11.331C20.8185 15.9323 16.83 19.662 11.9093 19.662C11.0198 19.662 10.161 19.5405 9.35025 19.3132L6.30975 21V17.811C4.29075 16.284 3 13.9485 3 11.331ZM10.5435 11.778L12.8475 14.172L17.7128 9.009L13.275 11.463L10.971 9.069L6.10575 14.232L10.5435 11.778Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const FacebookMessengerFilled = React.forwardRef(IconComponent);
FacebookMessengerFilled.displayName = 'FacebookMessengerFilled';

export { FacebookMessengerFilled };
